export default __webpack_public_path__ + "tab2_video_poster_m998fdf.png";